/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts (Callback Profiles)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Default form state values for Callback Profiles.

────────────────────────────────────────────────────────────────*/

import { FormState } from '../types';

export const getDefaultFormState = (): FormState => ({
  name: '',
  description: '',
  callbackKey: '1',
  confirmSound: 'ivr/press_1_to_confirm.wav',
  thanksSound: 'ivr/thank_you_callback.wav',
  timeoutSeconds: '3600',
  retryInterval: '300',
  maxAttempts: '3',
  strategy: 'same-queue',
  announcementSound: 'ivr/please_wait_callback.wav',
  enabled: true,
  createdAt: null,
  updatedAt: null
});

